<div [ngStyle]="style" #glyphContainer>
    @if (iconFont) {
        <i class="fa" [ngClass]="iconFont"></i>
    }
</div>
